exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articlePageHeader\n{\n    font-size: 28pt;\n    font-weight: 800;\n}\n\n#firstArticlePageHeader\n{\n    padding-top: 4vh;\n    padding-bottom: 4vh;\n    line-height: 26pt;\n}\n\n@media (max-width: 992px)\n{\n    .articlePageHeader\n    {\n        font-size: 30pt;\n        text-align: center;\n        padding-top: 3vh;\n        padding-bottom: 3vh;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/pageSectionFirstHeader/pageSectionFirstHeader.component.css
// module id = ../../../../../src/app/components/pageSectionFirstHeader/pageSectionFirstHeader.component.css
// module chunks = main